import React from 'react';
import Badge from './Badge';
import Separator from './Separator';
import about from "../assets/about/about.png"
import { Link } from 'react-router-dom';
const About2 = () => {
  return (
    <section id='nosotros' className='overflow-hidden bg-blue-950 border-t-2 border-b-2 border-blue-950'>
        <div className='bg-about bg-cover bg-no-repeat bg-left-bottom w-screen h-screen flex flex-col justify-center items-center relative'>
            <div className='container mx-auto'>
                <div className='flex gap-[30px] relative'>
                    {/* texto */}
                    <div className='flex-1 flex flex-col justify-center items-center'>
                        <Badge containerStyles="w-[180px] h-[140px]" />
                        <div className='max-w-[560px] text-center'>
                            {/* título */}
                            <h2 className='h2 text-white mb-4'>
                                <span className='mr-4'>
                                    Nuestro
                                </span>
                                <span className='text-accent'>
                                    Viaje
                                </span>
                            </h2>
                            {/* separador */}
                            <div className='mb-8'>
                                <Separator />
                            </div>
                            {/* descripción */}
                            <p className='leading-relaxed mb-16 text-white px-8 xl:px-0'>
                                Desde 2014, hemos crecido y evolucionado, aprovechando nuestra experiencia en buceo y operaciones submarinas. Hemos establecido alianzas estratégicas y adoptado tecnología de vanguardia, lo que nos ha permitido ofrecer servicios de alta calidad y ganar la confianza de importantes clientes. Hoy, seguimos comprometidos con la seguridad y la excelencia en cada proyecto.
                            </p>
                            {/* btn */}
                            <Link to="/nosotros">
                                <button className='btn'>
                                    Ver más
                                </button>
                            </Link>
                        </div>
                    </div>
                    {/* imagen */}
                    <div className='hidden xl:flex flex-1 w-full h-[70vh] relative'>
                        <img 
                            src={about}
                            fill
                            className='object-contain'
                            quality={100}
                            priority
                            alt='/'
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
    
  )
}

export default About2